import React from 'react'
import { connect } from 'react-redux'
import Col from 'muicss/lib/react/col'
import Row from 'muicss/lib/react/row'
import { Tabs, Tab } from 'material-ui/Tabs'
import Panel from 'muicss/lib/react/panel'

import Campaigns from './Campaigns'
import Profile from './Profile'
import Activities from './Activities'
import Prizes from './Prizes'
import { loadUserProfile, loadOwnPrizes } from '../../actions'
import firebase from '../../middleware/firebase'

const styles = {
  container: {
    margin: '10px',
  },
  section: {
    backgroundColor: '#ffffff',
  },
  campaigns: {
    backgroundColor: '#ffffff',
  },
  perfil: {
    backgroundColor: '#ffffff',
    padding: '10px',
  },
  activity: {
    backgroundColor: '#ffffff',
    marginTop: '10px',
    padding: '10px',
  },
  panel: {
    padding: 0,
  },
}

class Main extends React.Component {

  constructor() {
    super()
    this.state = {
      current_tab: 4,
    }
  }

  componentDidMount = () => {
    this.props.loadUserProfile(this.props)
    this.props.loadOwnPrizes()
    this.realdidMount = setInterval(
      () => {
        firebase.new_click(5)
        clearInterval(this.realdidMount)
      },
      2000,
    )
  }

  componentWillUnmount() {
    clearInterval(this.realdidMount)
  }

  tab = menu => () => {
    if (menu !== this.state.current_tab) {
      this.setState({ tab: menu })
      firebase.new_click(menu)
    }
  }

  render = () => (
    <Row style={styles.container}>
      <Col xs="12" md="4" md-offset="1">
        <Panel>
          <Profile />
        </Panel>
      </Col>
      <Col xs="12" md="6" >
        <Col style={styles.section}>
          <Panel style={styles.panel}>
            <Tabs>
              <Tab label="Campañas" onClick={this.tab(4)}>
                <Campaigns />
              </Tab>
              <Tab label="Actividad" onClick={this.tab(1)}>
                <Activities />
              </Tab>
              <Tab label="Premios" onClick={this.tab(3)}>
                <Prizes />
              </Tab>
            </Tabs>
          </Panel>
        </Col>
      </Col>
    </Row>
  )

}

const mapStateToProps = state => ({
  ...state.user,
})

const mapDispatchToProps = dispatch => ({
  loadUserProfile: user => dispatch(loadUserProfile(user)),
  loadOwnPrizes: () => dispatch(loadOwnPrizes()),
})

export default connect(mapStateToProps, mapDispatchToProps)(Main)



// WEBPACK FOOTER //
// ./src/components/Main/index.jsx